import { useQuery } from "react-query";
import { PaginatedFilter } from "../types/axios.types";
import { fetchMaterialsPaginated } from "../queries/material.queries";

export const useMaterialsPaginated = (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const query = useQuery(
		["materials-paginated", page, size, search, filters, sortBy],
		() => {
			try {
				return fetchMaterialsPaginated(page, size, search, filters, sortBy);
			} catch (err) {
				return null;
			}
		},
		{ keepPreviousData: true },
	);
	return query?.data;
};
